var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-modal',{attrs:{"size":"large","title":_vm.$t('account module configuration'),"icon":"settings","image":"/images/icons/accounts.png","scrolling":true,"show_ok":false,"show_cancel":false},on:{"destroy":_vm.destroy}},[_c('div',{staticClass:"description"},[_c('account-types')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }